/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { ShoppingListGetResponse } from "../models/ShoppingListGetResponse";
import type { ShoppingListUpdateRequest } from "../models/ShoppingListUpdateRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class ShoppingListService {
  /**
   * Get Shopping List
   * Get the shopping list for a user with full ingredient details.
   *
   * Process:
   * 1. Fetch shopping list from ShoppingListTable by userId (has ingredientId + isTicked)
   * 2. Extract all ingredient IDs
   * 3. Batch get details from:
   * - CSV (for standard meals)
   * - ShoppingListIngredientsTable (for Your Food meals)
   * 4. Enrich and return
   * @param xUserId
   * @returns ShoppingListGetResponse Successful Response
   * @throws ApiError
   */
  public static getShoppingListApiV1ShoppingListGet(
    xUserId: string,
  ): CancelablePromise<ShoppingListGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/shopping-list",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Shopping List Ticked Status
   * Update the ticked status of ingredients in the shopping list.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static updateShoppingListTickedStatusApiV1ShoppingListPut(
    xUserId: string,
    requestBody: ShoppingListUpdateRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/shopping-list",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
